import styled from "styled-components";
import { WhichSlide } from "../ProxiesDemo";
import { bodyTextRegular, accentColor } from "./style";

const BottomNavigationContainer = styled.div`
    position: fixed;
    // min-height: 50px;
    padding: 5px 0px;
    bottom: 0px;
    left: 0px;
    width: 100%;
    ${bodyTextRegular}
    font-size: 1.3rem;
    background-color: rgba(255,255,255,0.98);
    border-top: 1px solid #F0F0F0;
    z-index: 2000;
    box-shadow: 2px -2px 3px #C0C0C0;

`;

const NavigationUl = styled.ul`
    display: flex;
    flex-direction: row;
    margin: 0px;
    padding: 5px 20px;
    list-style-type: none;
    justify-content: space-around;
`;

const NavigationLi = styled.li`
    flex: 0 1 auto;
    margin: 0px 10px 0px 0px;
    cursor: pointer;

    color: #a0a0a0;

    &.highlighted {
        color: ${accentColor};
        font-weight: bold;
    }

`;

const NavigationArrowSpacer = styled(NavigationLi)`
    flex: 0 1;
    cursor: default;
    margin-left: 10px;
        margin-right: 10px;
`;



const BottomNavigationBar = ({ currentSlide, changeSlide }) => {

    const handleClick = ({ whichSlide }) => {

        changeSlide(whichSlide);

    }

    const NavigationMenuItem = ({ slideId, label }) => {

        let useClassName = slideId === currentSlide ? "highlighted" : "";

        return <NavigationLi onClick={() => handleClick({ whichSlide: slideId })} className={useClassName}>{label}</NavigationLi>
    }

    return <BottomNavigationContainer>
        <NavigationUl>
            <NavigationMenuItem slideId={WhichSlide.Landing} label={"Introduction"} />
            <NavigationArrowSpacer>→</NavigationArrowSpacer>
            <NavigationMenuItem slideId={WhichSlide.VideoSample} label={"Purpose"} />
            <NavigationArrowSpacer>→</NavigationArrowSpacer>
            <NavigationMenuItem slideId={WhichSlide.LoopStructure} label={"Structure"} />
            <NavigationArrowSpacer>→</NavigationArrowSpacer>
            <NavigationMenuItem slideId={WhichSlide.VisExplanation} label={"Visualization"} />
            <NavigationArrowSpacer>→</NavigationArrowSpacer>
            <NavigationMenuItem slideId={WhichSlide.VisDemo} label={"Demo"} />
            <NavigationArrowSpacer>→</NavigationArrowSpacer>
            <NavigationMenuItem slideId={WhichSlide.CreativeTeam} label={"Learn More"} />

        </NavigationUl>
    </BottomNavigationContainer>

}

export default BottomNavigationBar;